import StudentRequestRow from './StudentRequestRow';
import { RequestsDTO } from '../../../api/Courses/GetAllRequests';

const StudentRequestTable = ({ data }: { data?: RequestsDTO[] }) => {

    return (
        <div>
            <div className="overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch">
                <table className="table-auto w-full">
                    <thead className="text-lg capitalize">
                        <tr className="bg-[#F1F4F9] rounded-t-lg">
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">Full Name</div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">Phone</div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">Student Status</div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">Course Name</div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-left text-sm">Price</div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-center text-sm">Status</div>
                            </th>
                            <th className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
                                <div className="text-center text-sm">Approve</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="text-sm">
                        {data?.map((request: RequestsDTO) => (
                            <StudentRequestRow
                                key={request?.id}
                                requestId={request.id}
                                fullName={`${request?.student?.firstName} ${request?.student?.lastName}`}
                                studentStatus={`${request?.student?.status}`}
                                phone={request?.student?.phone}
                                courseName={request?.course?.name}
                                currency={request.egp ? "EGP" : "USD"}
                                coursePrice={request.egp ? request?.course?.discountPrice_egp : request?.course?.discountPrice_usd}
                                status={request?.status}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default StudentRequestTable;
